<mat-card [style.background]="'url(' + shape + ') no-repeat'" [routerLink]="pageToRedirect" [ngClass]="{ disabled: grey }">
	<mat-card-content class="content">
		<p>{{ text }}</p>
	</mat-card-content>
	<img mat-card-sm-image [src]="img" />
</mat-card>
